class UserFlagsService {
    static getUserFlagsAsURLParams(appendParams) {
        const userFlags = localStorage.getItem('user-flags');
        if (userFlags) {
            const flags = userFlags.split(';');
            console.log(`Applying user flags = '${flags}'`);
            if (flags.length > 0) {                
                const startingWith = (appendParams ? "&" : "?");
                return startingWith + flags.join("&");
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    static isFlagEnabled(flagName) {
        const userFlags = localStorage.getItem('user-flags');
        
        if (userFlags) {
            const flags = userFlags.split(';');
            const foundFlag = flags.filter((f) => f.startsWith(flagName));
            if (foundFlag && foundFlag.length > 0) {
                const flagValues = foundFlag[0].split('=');
                return flagValues.length == 2 && flagValues[1] == 'true';
            } 
        }

        return false;
    }
}

export default UserFlagsService;